export type AppRole =
  | 'school_admin'
  | 'slt'
  | 'head_teacher'
  | 'department_leader'
  | 'teacher'
  | 'parent'
  | 'trust_leader'
  | 'super_admin';

export const ROLE_LABELS: Record<AppRole, string> = {
  school_admin: 'Admin',
  slt: 'SLT',
  head_teacher: 'SLT',
  department_leader: 'Department Leader',
  teacher: 'Teacher',
  parent: 'Parent',
  trust_leader: 'Trust Leader',
  super_admin: 'Super Admin',
};

export function isSchoolAdminRole(role: AppRole): boolean {
  return role === 'school_admin';
}

export function isSchoolWideRole(role: AppRole): boolean {
  return role === 'school_admin' || role === 'slt' || role === 'head_teacher';
}

export function isSuperAdminRole(role: AppRole): boolean {
  return role === 'super_admin';
}

export function getPrimaryRoleLabel(role: AppRole | null | undefined): string {
  return role ? ROLE_LABELS[role] : 'Member';
}
